import { LanguagePreferenceEnum } from 'src/enums/language.enum';
import { LayoutViewType } from 'src/enums/user.enum';

export const defaultNotificationPageSize = 8;

export const getLogoFromLayout = (layout: LayoutViewType, mainTheme: 'dark' | 'light') => {
  switch (layout) {
    case LayoutViewType.SAMA_RED_LAYOUT:
      return '/headerLogos/SAMA_RED.png';
    case LayoutViewType.NGINR_LAYOUT:
      if (mainTheme === 'dark') {
        return './nginr_LOGO_yatay_negatif.png';
      }
      return './nginr_LOGO_yatay.png';
    case LayoutViewType.SAMA_BLACK_LAYOUT:
      return '/headerLogos/Sama_Black.png';
    case LayoutViewType.FULL:
      if (mainTheme === 'dark') {
        return './nginr_LOGO_yatay_negatif.png';
      }
      return './nginr_LOGO_yatay.png';
    // return '/headerLogos/sama_isr.png';
    default:
      return '';
  }
};

export const getLayoutImage = (
  layout: LayoutViewType,
  mainTheme: 'dark' | 'light',
  lang: LanguagePreferenceEnum = LanguagePreferenceEnum.EN,
) => {
  switch (layout) {
    case LayoutViewType.SC3_LAYOUT:
      return '/landing_layout.svg';
    case LayoutViewType.SAMA_RED_LAYOUT:
      if (lang === LanguagePreferenceEnum.AR) {
        return '/Logo_DMSC_ar.png';
      }
      return '/Logo_DMSC.png';
    case LayoutViewType.NGINR_LAYOUT:
      if (mainTheme === 'dark') {
        return './nginr_LOGO_dikey_negatif.png';
      }
      return './nginr_LOGO_dikey.png';
    case LayoutViewType.SAMA_BLACK_LAYOUT:
      return '/headerLogos/Sama_Black.png';
    case LayoutViewType.FULL:
      if (mainTheme === 'dark') {
        return './nginr_LOGO_dikey_negatif.png';
      }
      return './nginr_LOGO_dikey.png';
    // return '/headerLogos/sama_isr.png';
    default:
      return '';
  }
};
